import React from 'react';
import { BrowserRouter as Router, Route, Switch, useHistory } from 'react-router-dom';
import { SecureRoute, Security, LoginCallback } from '@okta/okta-react';
import { OktaAuth, EVENT_EXPIRED, toRelativeUrl } from '@okta/okta-auth-js';
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

import Routes from './routes/index';
import SurveyRoute from './routes/survey';

import { ISSUER, CLIENT } from "./constants";

import AlertEmail from './components/AlertEmail/AlertEmail';
import AlertsEmail from './components/AlertsEmail/AlertsEmail';

import "./App.css";

export default function App() {
  // Remove Pendo 
  window.pendo = {
  initialize: () => {}
  };
  console.log("process", process);
  console.log("process.env", process.env);
  const oktaAuth = new OktaAuth({
    issuer: ISSUER,
    clientId: CLIENT,
    redirectUri: window.location.origin + '/implicit/callback',
    tokenManager: {
      autoRenew: false,
      autoRemove: false
    }
  });
  const history = useHistory();
  const restoreOriginalUri = async (oktaAuth, originalUri) => {
    console.log("original uri: " + originalUri);
    if (originalUri === 'http://localhost:3000/research') {
      history.replace(toRelativeUrl('/', window.location.origin))
    }
    else if (originalUri === 'http://localhost:3000/SeriesReportAlertsList') {
      history.replace(toRelativeUrl('/', window.location.origin))
    }
    else {
      history.replace(toRelativeUrl(originalUri, window.location.origin))
    }
  }
  oktaAuth.tokenManager.on(EVENT_EXPIRED, async (key) => {
    const existingToken = await oktaAuth.tokenManager.get(key);
    oktaAuth.token.renew(existingToken)
      .then(newToken => {
        oktaAuth.tokenManager.add(key, newToken);
      })
      .catch(e => {
        oktaAuth.tokenManager.remove(key);
      });
  });
  return (
    <DndProvider backend={HTML5Backend}>
      <Security
        oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}
      >
        <Switch>
          <Route
            path="/responsive"
            render={() => {
              window.location.replace('https://research.jll.com');
              return null;
            }}
          />
          <Route path='/implicit/callback' component={LoginCallback} />
          <SecureRoute path="/survey" component={SurveyRoute} />
          <SecureRoute path="/AlertEmail/DocNum=:DocNum" component={AlertEmail} />
          <SecureRoute path="/AlertsEmail/BatchNum=:BatchNum" component={AlertsEmail} />
          <SecureRoute path="/" component={Routes} />
        </Switch>
      </Security>
    </DndProvider>
  );
}
